@if (article().article_type; as articleType) {
  <span class="font-bold">{{ 'pages.articles.articleType' | translate }}:</span>
  {{ ' ' }}
  <span>{{ 'articleTypes.' + articleType.name | translate }}</span>
  <br />
}
